/* global Blockly */
import React from 'react';

function defineBlock(context, _playServerSound) {

    return {
        soundOptions: [],
        defaultOption: '- select -',
        init: function () {
            let testButton = {primary:'#ffffff', secondary:'#000000', tertiary:'#C1C1C1', text:'#7200e7'};

            // gather sound options
            this.soundOptions = [];
            this.soundOptions.push(['Custom sounds', '[LABEL]']);
            context.customSounds && this.soundOptions.push(...context.customSounds.map(sound => [sound.Name, sound.Id]));
            this.soundOptions.push(['', 'SEPARATOR']);
            this.soundOptions.push(['Default sounds', '[LABEL]']);
            context.defaultSounds && this.soundOptions.push(...context.defaultSounds.map(sound => [sound.Name, sound.Id]));

            this.appendValueInput("VALUE")
                .appendField("play ")
                .appendField(new Blockly.FieldDropdown(this.soundOptions, undefined, this.defaultOption), "SOUND")
                .appendField(" at volume ")
                .setCheck(["Number"])

            var volumeId = this.workspace.newBlock("custom_number");
            volumeId.setProperties({
                defaultValue: 100, 
                minValue: 0, 
                maxValue: 100,
                maxLength: 3,
                allowDecimals: false 
            });
            volumeId.setShadow(true);
            this.getInput("VALUE").connection.connect(volumeId.outputConnection);
            
            this.appendDummyInput("TEXT")
                .appendField("%  ")
            this.appendDummyInput('TEST')
                .appendField(new Blockly.FieldButton( ' Test ', testButton, this._testSound.bind(this)), 'TEST')
                .setOnNewRow(false);
            this.appendDummyInput("FINISHED")
                .appendField("on sound finished")
                .setOnNewRow(true);
            
            this.appendStatementInput('CALLBACK');

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Play from a list of pre-determined sounds');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#Sounds');

            this.setOnChange(this._changeHandler);
        },

        // make sure legacy blocks and deleted sounds are supported
        _changeHandler: function() {
            const soundId = this.getFieldValue('SOUND');
            if (!soundId || soundId === this.defaultOption) {
                return;
            }
            if (!this.soundOptions.find(option => option[1] === soundId)) {
                const updatedSoundId = `DEFAULT:${parseInt(soundId) + 1}`;
                if (!this.soundOptions.find(option => option[1] === updatedSoundId)) {
                    // sound was deleted, mark this block as unset and show warning
                    const field = this.getField('SOUND');
                    this.setFieldValue(this.defaultOption, 'SOUND')
                    field.hasBeenSet = false;
                    field.setWarning(true);
                    const closure = field.onChange;
                    field.setOnChange(function (v) {
                        field.setWarning(false);
                        field.setOnChange(closure);
                        if (closure) {
                            closure.call(field, v);
                        }
                    });
                } else {
                    // convert legacy id to the updated default sound id
                    this.setFieldValue(updatedSoundId, 'SOUND');
                }
            }
        },

        // play sound from SNAP server
        _testSound: function () {
            _playServerSound({
                id: this.getFieldValue('SOUND'),
                volume: Blockly.JavaScript.valueToCode(this, 'VALUE', Blockly.JavaScript.ORDER_NONE)
            });
        },
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const soundId = this.getFieldValue('SOUND');
            const callback = Blockly.JavaScript.statementToCode(block, 'CALLBACK');
            const volume = Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_NONE);
            return `SoundModule.playCustomSound('${soundId}', ${volume}, function() {
                    ${callback}
                });\n`;
        }
    }
}

const PlayBeep = function (props) {
    let name = 'snap_play_beep';
    PlayBeep.blockName = name;

    let context = {
        defaultSounds: props.context.defaultSounds,
        customSounds: props.context.customSounds
    };

    Blockly.Blocks[name] = defineBlock(context, props.playServerSound);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }
 
    return <block type={name}></block>;
}

export default PlayBeep;
